import { memo, useContext, useEffect, useRef, useState } from 'react'

import { Box, BoxProps } from '@mantine/core'

import { AirPopulationContext } from '../context'
import 'odometer/themes/odometer-theme-default.css'

export const MainValue = memo((props: BoxProps) => {
  const { data } = useContext(AirPopulationContext)
  const { currentAqiusValue = 0 } = data || {}

  const elRef = useRef<HTMLDivElement | null>(null)
  const odRef = useRef<any>(null)
  const [OdometerLib, setOdometerLib] = useState<any>(null)
  const prevValue = useRef<number>(0)

  useEffect(() => {
    import('odometer').then(({ default: Odometer }) => {
      setOdometerLib(() => Odometer)
    })
  }, [])

  useEffect(() => {
    if (!OdometerLib || !elRef.current) return

    elRef.current.innerHTML = ''

    const span = document.createElement('span')
    span.textContent = String(Math.round(Number(currentAqiusValue)) || 0)
    elRef.current.appendChild(span)

    const od = new OdometerLib({
      el: span,
      value: Math.round(Number(currentAqiusValue)) || 0,
      theme: 'default',
      format: '(,ddd)',
    })

    odRef.current = od
    prevValue.current = Math.round(Number(currentAqiusValue)) || 0

    setTimeout(() => od.update(prevValue.current), 100)
  }, [OdometerLib])

  useEffect(() => {
    if (!odRef.current) return

    const newValue = Math.round(Number(currentAqiusValue)) || 0
    const oldValue = prevValue.current
    prevValue.current = newValue

    if (newValue === oldValue) return

    const diff = Math.abs(newValue - oldValue)
    const duration = Math.max(200, Math.min(diff * 30, 300)) // 200ms–1500ms
    const ribbons = document.querySelectorAll('.odometer-ribbon-inner')
    ribbons.forEach((el) => {
      el.setAttribute(
        'style',
        `transition-duration: ${duration}ms !important; transition-timing-function: cubic-bezier(0.4,0,0.2,1) !important;`,
      )
    })
    odRef.current.update(newValue)
  }, [currentAqiusValue])

  return (
    <Box
      {...props}
      ref={elRef}
      sx={{
        overflow: 'hidden',
      }}
    />
  )
})
